import { Outlet } from 'react-router-dom'
import { canViewCustoms } from '@crm/shared'
import { useAuthStore } from '../auth/authStore'
import { EmptyState } from '../../shared/ui/EmptyState'

/**
 * Ворота раздела «Нетарифка» (логист, Л1–Л3, docs/features/nontariff.md): пускают
 * логиста, ADMIN, генерального директора и РОЗ (`CUSTOMS_VIEW_ROLES`). Остальным —
 * заглушка без запросов к API. Раздел живёт вне `CrmRoleGate`: логист — роль
 * этапа 3, а менеджеру, закупщику, РОП и помощнику раздел не нужен (API вернёт 403).
 */
export function CustomsRouteGate() {
  const role = useAuthStore((s) => s.user?.role)
  if (!canViewCustoms(role)) {
    return (
      <div className="p-6">
        <EmptyState
          title="Раздел недоступен"
          description="Нетарифку ведёт логист; раздел видят также администратор, генеральный директор и РОЗ."
        />
      </div>
    )
  }
  return <Outlet />
}
